// console.log(process.env);
module.exports = [{
    "/": {
        title: 'Custom Channels Player',
        stream_url: 'http://ccice.streamguys.com:80/luckys_market_west_96.mp3',
        nowplaying_url: 'https://ensemble.customchannels.net/api/channels/446/recent',
        remix: false
    },
    "/elephant-in-the-room": {
        title: 'Elephant In The Room',
        stream_url: 'http://stream.customchannels.net/elephant_in_the_room_96.mp3',
        nowplaying_url: 'https://ensemble.customchannels.net/api/channels/2633/recent',
        remix: false
    },
    "/mcintosh/mobile": {
        title: 'McIntosh Music',
        stream_url: 'http://ccice.streamguys.com/mcintosh_master_96.mp3',
        nowplaying_url: 'https://ensemble.customchannels.net/api/channels/205/recent',
        remix: false
    },
    "/remix": {
        title: "ReMix Stream",
        stream_url: 'https://ensemble.customchannels.net/mp3/1454',
        nowplaying_url: 'https://ensemble.customchannels.net/api/channels/1454/recent',
        remix: true
    },
    "/bonnaroo/player": {
      title: 'Bonnaroo',
      stream_url: 'https://stream.customchannels.net/bonnaroo_96.mp3',
      nowplaying_url: 'https://ensemble.customchannels.net/api/channels/1964/recent',
      remix: false
    },
    "/betterthansex": {
      title: 'Better Than Sex',
      stream_url: 'http://mobile.customchannels.net/better_than_sex_96.mp3',
      nowplaying_url: 'https://ensemble.customchannels.net/api/channels/1182/recent',
      remix: false
    },
    "/streaming/griffis/mobile": {
      title: 'Griffis',
      stream_url: 'http://ccice.streamguys.com:80/griffis_96.mp3',
      nowplaying_url: 'https://ensemble.customchannels.net/api/channels/741/recent',
      remix: false
    },
    "/whichwich/mobile": {
      title: 'Which Wich',
      stream_url: 'http://mobile.customchannels.net/which_wich_96.mp3',
      nowplaying_url: 'https://ensemble.customchannels.net/api/channels/185/recent',
      remix: false
    },
    "/luckysmarket/mobile": {
      title: "Lucky's Market",
      stream_url: 'http://ccice.streamguys.com/luckys_market_west_96.mp3',
      nowplaying_url: 'https://ensemble.customchannels.net/api/channels/446/recent',
      remix: false
    },
    "/mashd": {
      title: "Mash'd",
      stream_url: 'http://mobile.customchannels.net/mashd_96.mp3',
      nowplaying_url: 'https://ensemble.customchannels.net/api/channels/148/recent',
      remix: false
    },
    "/modpizza": {
      title: "MOD Pizza",
      stream_url: 'http://stream.customchannels.net/mod_pizza_96.mp3',
      nowplaying_url: 'https://ensemble.customchannels.net/api/channels/151/recent',
      remix: false
    },
    "/streaming/mod_pizza/mobile": {
      title: "MOD Pizza",
      stream_url: 'http://stream.customchannels.net/mod_pizza_96.mp3',
      nowplaying_url: 'https://ensemble.customchannels.net/api/channels/151/recent',
      remix: false
    },
    "/streaming/mooyah/mobile": {
      title: "Mooyah",
      stream_url: 'http://mobile.customchannels.net/mooyah_96mp3',
      nowplaying_url: 'https://ensemble.customchannels.net/api/channels/155/recent',
      remix: false
    },
    "/sportsclubla": {
      title: "Sports Club LA",
      stream_url: 'http://stream.customchannels.net/sportsclub_la_96.mp3',
      nowplaying_url: 'https://ensemble.customchannels.net/api/channels/173/recent',
      remix: false
    },
    "/streaming/wholefoods/mobile": {
      title: "Whole Foods Market Radio",
      stream_url: 'http://stream.customchannels.net/wfm_128.mp3',
      nowplaying_url: 'https://ensemble.customchannels.net/api/channels/332/recent',
      remix: false
    },

}]



// WEBPACK FOOTER //
// ./src/playerData.js